import { initOtel } from './sdk'

initOtel({})
